var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.hideButton ? _c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.text)) + " ")]) : _vm._e(), _vm.isDialogActive ? _c('confirm-action-dialog', {
    attrs: {
      "width": "1050",
      "persistent": true,
      "supressKeyboardActions": true,
      "title": _vm.dialogStep.title,
      "subtitle": _vm.dialogStep.subtitle,
      "isDialogActive": _vm.isDialogActive,
      "leftText": _vm.dialogStep.leftText,
      "rightText": _vm.dialogStep.rightText,
      "loading": _vm.isLoading,
      "rightLoading": _vm.isLoading,
      "rightDisabled": _vm.dialogStep.rightDisabled,
      "fullscreen": _vm.dialogStep.fullscreen
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "close": _vm.close,
      "leftClick": _vm.dialogStep.leftClick,
      "rightClick": _vm.dialogStep.rightClick
    }
  }, [_c('v-window', {
    staticClass: "fill-height",
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.CreateInvoiceWindow.START
    }
  }, [_c('v-row', [_c('v-col', [_c('drop-area-multi', {
    staticClass: "my-2",
    attrs: {
      "files": _vm.files,
      "text": _vm.$t('cost.dragAndDropDocuments'),
      "dragoverText": _vm.$t('sign.SignDocumentCreateDialog.title'),
      "loading": _vm.isLoading,
      "accept": ".pdf",
      "maxFiles": 1
    },
    on: {
      "update:files": function updateFiles($event) {
        _vm.files = $event;
      }
    }
  })], 1)], 1)], 1), _c('v-window-item', {
    staticClass: "fill-height",
    attrs: {
      "value": _vm.CreateInvoiceWindow.CREATE
    }
  }, [_c('v-row', {
    staticClass: "fill-height overflow-y-auto"
  }, [_vm.pdf ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "fill-height"
  }, [_c('iframe', {
    staticClass: "pdf",
    attrs: {
      "title": "pdf",
      "src": _vm.pdf
    }
  })])]) : _vm._e(), _vm.invoice ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('invoice-inbound-form', {
    staticClass: "pt-1",
    attrs: {
      "coverageType": _vm.coverageType
    },
    on: {
      "isValid": function isValid($e) {
        return _vm.isValid = $e;
      }
    },
    model: {
      value: _vm.invoice,
      callback: function callback($$v) {
        _vm.invoice = $$v;
      },
      expression: "invoice"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _c('debug', [_vm._v(" " + _vm._s(_vm.invoice) + " ")])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }